import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: 90vh;

  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: center;
`;

export const WrapperInfo = styled.section`
  width: 50%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  text-align: center;

  ${({ theme }) => css`
    color: ${theme.colors.primary};
  `}

  > p {
    margin-top: 2rem;
  }
`;
